import {default as RcsProvider} from './RcsProvider'

export { RcsProvider };



// WEBPACK FOOTER //
// src/modules/screens/settings/RcsProvider/components/index.js